import React, { Component } from 'react';
import { getPlan, CreatePay, partnerApi } from './../../../../API/FetchCall';
import SimpleReactValidator from 'simple-react-validator';
var CurrencyFormat = require('react-currency-format');
import { RAZORPAY_LIVE, RAZORPAY_TEST } from '../../../../constant.js';

class Renewal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      pname: '', planselect: false, errors: [],
      planlist: [], upgradeplanid: '', planid: 0, plan_price: '', discamt: '', originalprice: '',
      is_active: false, expire: '', payable_amt: 0

    }
    this.validator = new SimpleReactValidator();
    this.getcurrentPlan();
    this.getPlanList();
  }
  componentDidUpdate() {
    //window.jQuery('.selectpicker').selectpicker('refresh');
  }
  componentDidMount() {
  }
  getcurrentPlan = async () => {
    let insdata = JSON.stringify({
      user_type: this.state.auth_data.user_type,
      vendor_id: this.state.auth_data.login_id,
      url: 'getCurrentPlan'
    })
    partnerApi(insdata).then((response) => {
      if (response.status === 1) {
        let data = response.results;
        const diffTime = Math.abs(new Date(data.expire) - new Date());
        const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        console.log('daysLeft', daysLeft)
        let date = data.start_date ? new Date(data.start_date) : '';
        let enddate = data.end_date ? new Date(data.end_date) : '';
        let final_date = date ? date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear() : '';
        let end_date = enddate ? enddate.getDate() + "-" + (enddate.getMonth() + 1) + "-" + enddate.getFullYear() : '';
        this.setState({
          pname: data.plan_name,
          payment_date: final_date,
          expire: data.expire,
          enddate: end_date,
          planamount: data.plan_amount,
          payable_amt: (data.current_price),
          planid: data.planid,
          is_active: daysLeft > 1 ? true : false
        });
      }
    });
  }
  getPlanList = async () => {
    try {
      let planData = JSON.stringify({
        user_type: this.state.auth_data.user_type,
      });

      getPlan(planData).then((response) => {
        if (response.status == 1) {
          const { current_plan } = this.state.auth_data;
          var filtered = response.results.filter(item => item.id == current_plan);
          if (filtered.length > 0) {
            let data = filtered[0];
            this.setState({
              discamt: data.discount_amount,
              plan_price: data.discount_amount,
              payable_amt: (data.plan_price),
              originalprice: data.base_price,
            });
          }

        } else {
          console.log('else')
        }
      });
    } catch (error) {
      this.setState({ error: true });
    }
  }

  render() {

    console.log('sate', this.state.planlist)
    this.validator.purgeFields();
    return (
      <React.Fragment>
        <div class="box-shadow-custom">
          <div class="row">
            <div class="form-group min-h-unset col-md-6">
              <label>Package Name : &nbsp;&nbsp;</label>
              <span>{this.state.pname}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group min-h-unset col-md-6">
              <label>Status : &nbsp;&nbsp;</label>
              {this.state.is_active ?
                (
                  <span className='label label-primary'>Active</span>
                )
                :
                (
                  <span className='label label-danger'>Expired</span>
                )
              }
            </div>
          </div>
          <div class="row">
            <div class="form-group min-h-unset col-md-6">
              <label>Expire Date : &nbsp;&nbsp;</label>
              <span>{this.state.enddate}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group min-h-unset col-md-6">
              <label>Payable Amount : &nbsp;&nbsp;</label>
              <CurrencyFormat value={this.state.payable_amt ? this.state.payable_amt : '0'}
                displayType={'text'} thousandSeparator={true} prefix={'₹'} />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <button type='submit' className="btn btn-primary" onClick={this.displayRazorpay}>PAY</button>
            </div>
          </div>
        </div>

      </React.Fragment>
    );

  }
  displayRazorpay = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      const res = await this.loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );
      if (!res) {
        alert("Razorpay SDK failed to load. Are you online?");
        return;
      }
      let ins = JSON.stringify({
        amount: this.state.payable_amt
      });
      CreatePay(ins).then((res) => {
        this.setState({
          amount: res.amount,
          order_id: res.id,
          currency: res.currency,
        });
        this.payinfo();
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }
  payinfo() {
    var This = this;
    var payment_data;
    const options = {
      key: RAZORPAY_LIVE, // Enter the Key ID generated from the Dashboard
      amount: this.state.amount.toString(),
      currency: this.state.currency,
      name: this.state.auth_data.first_name,
      description: "Renewal - Partner Program",
      // image: { logo },
      // order_id: this.state.order_id,
      handler: async function (response) {
        console.log('response', response);
        This.handlePaySubmit(response);
        payment_data = response.razorpay_payment_id;
        const data = {
          // orderCreationId: this.state.order_id,
          razorpayPaymentId: response.razorpay_payment_id,
          razorpayOrderId: response.razorpay_order_id,
          razorpaySignature: response.razorpay_signature,
        };
        //  const result = await axios.post("/payment/success", data);
      },
      prefill: {
        name: this.state.auth_data.first_name,
        email: this.state.auth_data.email_address,
        contact: this.state.auth_data.phone_number,
      },
      notes: {
        address: this.state.auth_data.address,
      },
      theme: {
        color: "#61dafb",
      },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();

  }

  loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }


  handlePaySubmit(response) {
    let razorpay_payment_id = response.razorpay_payment_id;

    if (razorpay_payment_id != '') {
      let ins = '';
      ins = JSON.stringify({
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_order_id: response.razorpay_payment_id,
        razorpay_signature: response.razorpay_signature,
        amount: this.state.payable_amt,
        user_type: this.state.auth_data.user_type,
        user_paytype: 1,
        expire: this.state.expire,
        discount: this.state.discamt ? this.state.discamt : 0,
        discount_amount: this.state.plan_price ? this.state.plan_price : 0,
        plan_price_original: this.state.originalprice ? this.state.originalprice : 0,
        login_id: this.state.auth_data.login_id,
        is_active: this.state.is_active,
        plan_id: this.state.planid,
        url: 'plan_renewal'
      });

      partnerApi(ins).then((res) => {
        let toastr = '';
        if (res.status === 1) {
          toastr = window.toastr.success;
          toastr('', 'Your plan has been upgraded.', {
            positionClass: "toast-bottom-right",
            containerId: "toast-bottom-right"
          });
          setTimeout(function () {
            window.location.reload();
          }, 2000);
        } else {
          let er = res.errors[0].msg
          toastr = window.toastr.error; //warning
          toastr(er, toastr, {
            positionClass: "toast-bottom-right",
            containerId: "toast-bottom-right"
          });
        }
      });
    } else {
      let toastr = '';
      toastr = window.toastr.error; //warning
      toastr('', 'Failed to Pay', {
        positionClass: "toast-bottom-right",
        containerId: "toast-bottom-right"
      });
    }
  }
}

export default Renewal;





// WEBPACK FOOTER //
// ./src/components/bewise/partners/subscribe/renewal.jsx